import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloseQuote2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCloseQuote2"><Path d="M10.5 4.5H2.5V12.5L6.5 12.5V19.5C6.5 19.5 10.5 17.8929 10.5 13.0714V4.5Z" stroke="currentColor"/><Path d="M21.5 4.5H13.5V12.5L17.5 12.5V19.5C17.5 19.5 21.5 17.8929 21.5 13.0714V4.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconCloseQuote2;
